import { portalApi } from "../../../services/api";

export async function fetchRelatorioEvento(props) {
  const res = await portalApi.get("relatorio-evento", {
    params: { ...props, flg_del: 0 },
  });
  const data = res.data.items;
  return data;
}
